import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { SystemModules } from '../domain/utils/constants/system-modules'
import { AuthGuard } from '../infra/auth/guard/auth.guard'
import { LoginGuard } from '../infra/auth/guard/login.guard'
import { NotFoundComponent } from './view/errors/not-found/not-found.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: SystemModules.home.uri,
  },
  {
    path: SystemModules.home.uri,
    loadChildren: () => import('./view/home/home.module').then((m) => m.HomeModule),
    canLoad: [ LoginGuard ]
  },
  {
    path: SystemModules.erp.uri,
    loadChildren: () => import('./view/erp/erp.module').then((m) => m.ErpModule),
    canLoad: [ AuthGuard ]
  },
  {
    path: SystemModules.external.uri,
    loadChildren: () => import('./view/external/external.module').then((m) => m.ExternalModule)
  },
  {
    path: '**',
    component: NotFoundComponent
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PresentationRoutingModule {}
